import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components/macro';
import { DescriptionText, PillButton, SectionTitle } from './styles';
import ReactSlick, { Settings } from 'react-slick';
import { Thumbnail } from './Thumbnail';
import { TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { StaticSplashThumbnail } from 'src/@types/StaticSplashResponse';
import { useStaticSplashContent } from './content/useStaticSplashContent';

type Props = {
  thumbnails: StaticSplashThumbnail[];
};

const sliderSettings: Settings = {
  arrows: true,
  dots: false,
  infinite: true,
  // autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 6,
  slidesToScroll: 6,
  nextArrow: (
    <PillButton>
      <FontAwesomeIcon icon={faChevronRight} />
    </PillButton>
  ),
  prevArrow: (
    <PillButton>
      <FontAwesomeIcon icon={faChevronLeft} />
    </PillButton>
  ),
  responsive: [
    // breakpoints are max-width settings
    {
      breakpoint: 575,
      settings: { slidesToShow: 2, slidesToScroll: 2 },
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 3, slidesToScroll: 3 },
    },
  ],
};

export const ClassicSection = (props: Props) => {
  const { classics } = useStaticSplashContent();

  return (
    <Wrapper>
      <InfoSection>
        <SectionTitle>{classics.title}</SectionTitle>
        <DescriptionText fullWidth>{classics.description}</DescriptionText>
      </InfoSection>
      <ReactSlick {...sliderSettings}>
        {props.thumbnails.map((thumbnail) => (
          <StyledThumbnail key={thumbnail.title} thumbnail={thumbnail} type="classics" />
        ))}
      </ReactSlick>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  grid-area: classic;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;

  .slick-slider {
    display: grid;
    align-items: center;
  }

  .slick-track {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }

  .slick-arrow {
    z-index: 10;
    margin: 0 5px;
    font-size: 20px;
    cursor: pointer;
    opacity: 0.7;

    // !important because the slider puts display block on the element in the dom
    display: 'flex' !important;
    background: none !important;

    &:hover {
      opacity: 1;
      background: none !important;
    }

    svg {
      filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.75));
    }
  }

  .slick-next {
    right: 0;
  }

  .slick-slide {
    overflow: hidden;
  }
`;

const InfoSection = styled.div`
  grid-area: description;
  padding: 10px 5px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${TABLET_PORTRAIT} {
    padding: 15px 10px;
  }
`;

const StyledThumbnail = styled(Thumbnail)`
  aspect-ratio: 412 / 620;
`;
